import { cn } from "@/shared/utils/cn";

export function Brand({ wordmark = false, className }: { wordmark?: boolean; className?: string }) {
  return (
    <span className={cn("inline-flex shrink-0 items-center gap-1.5 text-primary", className)}>
      <span aria-hidden="true" className="text-[30px] leading-none">
        <svg viewBox="0 0 32 32" fill="none" className="block h-[1em] w-[1em]" focusable="false">
          <circle cx="16" cy="16" r="13" stroke="currentColor" strokeWidth="2" />
          <path
            d="M8.4 13C7.9 10.3 9.2 8 11.4 8C13 8 14 9 14.6 10.2C15.5 10 16.5 10 17.4 10.2C18 9 19 8 20.6 8C22.8 8 24.1 10.3 23.6 13C24.2 14.1 24.5 15.3 24.5 16.5C24.5 21 21.3 24 16 24C10.7 24 7.5 21 7.5 16.5C7.5 15.3 7.8 14.1 8.4 13Z"
            fill="currentColor"
          />
        </svg>
      </span>
      {wordmark && <span className="text-[22px] font-extrabold tracking-tight">froppio</span>}
    </span>
  );
}
